import { Controparte } from "./controparte";
import { SoggettoPratica } from './tipologiche/soggetto-pratica';

export class FondoRischioControparte {
  id: string;
  controparte: Controparte;
  societa: SoggettoPratica;
  sorte: number;
  speseGiudizio: number;
  interessi: number;
  rivalutazione: string | number;
  assistenziali: string | number;
  previdenziali: string | number;
  tfr: string | number;
}
